var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropletArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 176,
    viewBox: "0 0 134 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 114C134 151 104 176 67 176C30 176 0 151 0 114C0 77 48 28 67 0C85 28 134 77 134 114Z",
    fill: "#004578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.51 34.1901C83.57 43.4601 90.16 53.52 96.14 63.77C99.33 69.24 106.14 65.35 102.36 59.93C95.17 49.63 87.2501 39.5001 79.9601 30.1901C76.8701 26.2501 73.8501 22.3901 71.0201 18.6901C68.9101 15.9201 66.5301 17.12 68.3401 20.4C71.0501 25.31 74.85 30.1301 77.51 34.1901Z",
    fill: "#0064A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropletArt);
export default __webpack_public_path__ + "static/media/droplet-art.ab1b10cbe9a0997546b9129ea4c6b29c.svg";
export { ForwardRef as ReactComponent };